import SupplierList from '@/views/repository/supplier-list.vue';
import RepositoryList from '@/views/repository/repository-list.vue';
import RepositoryDetail from '@/views/repository/repository-detail.vue';
import RepositoryAdd from '@/views/repository/repository-add.vue';

export default [
    {
        path: '/supplier/supplier-list',
        component: SupplierList,
        name: 'supplierList'
    },
    {
        path: '/repository/repository-list',
        component: RepositoryList,
        name: 'repositoryList'
    },
    {
        path: '/repository/repository-detail',
        component: RepositoryDetail,
        name: 'repositoryDetail'
    },
    {
        path: '/repository/repository-add',
        component: RepositoryAdd,
        name: 'repositoryAdd'
    },
    
]